//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';

// context containers
import {
  Hero,
  TextBlock,
  BackgroundImageSection,
  CarouselSection,
  ImageGridSection,
  VideosSection,
  TeamSection,
  QuoteSection,
  FeaturedIcons,
  ContentCollapse,
} from './containers-m/';

//styles
import { PageWrapper } from './Careers.styles';
import { ContentColumns } from '@/containers-m/ContentColumns';

const bgSection1 = {
  title: (
    <>
      Get to <br /> know our <br /> teams
    </>
  ),
  image: {
    xxlarge: 'images/careers/bgsection/get_to_know_our_teams_xxlarge@2x.jpg',
    large: 'images/careers/bgsection/get_to_know_our_teams_lg@2x.jpg',
    medium: 'images/careers/bgsection/get_to_know_our_teams_md@2x.jpg',
    small: 'images/careers/bgsection/get_to_know_our_teams_sm@2x.jpg',
  },
  CTA: {
    label: 'Explore open positions',
    link: 'https://jobs.lever.co/loadsmart/',
    external: true,
  },
};

const blockText2 = {
  title: 'Where to find us',
  description:
    'Whether our Loadies are working remote or at one of our global offices, we are always connected through our continual development of a community of dedicated employees and logistics professionals. No matter where you are located, you will find an environment of teamwork, fun and celebration of our achievements.',
  CTA: {
    label: 'Explore open positions',
    link: 'https://jobs.lever.co/loadsmart/',
    external: true,
  },
  inverted: true,
};

const bgSection2 = {
  title: 'Become a Loadie!',
  description:
    'We’re always looking to connect with world-class thinkers, strategists, doers, and leaders. Check out our open positions below.',
  image: {
    xxlarge: 'images/careers/bgsection/become_a_loadie_xxlarge@2x.jpg',
    large: 'images/careers/bgsection/become_a_loadie_lg@2x.jpg',
    medium: 'images/careers/bgsection/become_a_loadie_md@2x.jpg',
    small: 'images/careers/bgsection/become_a_loadie_sm@2x.jpg',
  },
  CTA: {
    label: 'Learn more',
    link: 'https://jobs.lever.co/loadsmart/',
    external: true,
  },
  biggerBg: true,
};

const Careers = () => {
  return (
    <PageWrapper>
      <Navigation />
      <>
        <Hero />

        <FeaturedIcons />
        <VideosSection />
        <CarouselSection />
        <BackgroundImageSection content={bgSection1} />
        <QuoteSection />
        <TeamSection />
        <TextBlock content={blockText2} />
        <ImageGridSection />
        <ContentColumns />
        <BackgroundImageSection content={bgSection2} />
      </>
      <Footer />
    </PageWrapper>
  );
};

export default Careers;
export { Careers };
